import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./PublicLayout.module.scss";
import PublicNavigation from "../../components/PublicNavigation/PublicNavigation";
import { selectLoggedIn } from "../../store/slices/auth/slice";

const PublicLayout = () => {
  const isAuthenticated = useSelector(selectLoggedIn);

  if (!isAuthenticated) {
    return (
      <div>
        <PublicNavigation />
        <div className={styles.fullHeightContainer}>
          <Outlet />
        </div>
      </div>
    );
  }

  return <Navigate to="/" />;
};

export default PublicLayout;
